<template>
  <div
    class="storefinder-block p-t-0"
    :class="{ '-full': storeIsActive && mobileViewMode === 'full' }"
  >
    <StoreFinderFilter
      v-if="showFilterRow"
      v-show="viewFiltersMobile"
      style="position: absolute; z-index: 100; top: 74px; left: 0"
      class="storefinder-block-search-filter"
      v-model="storeFilter"
      :options="toggleOptions"
      :backgroundColor="'transparent'"
      :fontColor="Globals.colors.black"
      :sliderColor="Globals.colors.white"
      @change="filterHasChanged"
    />
    <section class="storefinder-block-search">
      <div class="grid" style="height: 100%">
        <div
          v-if="!isMobile"
          class="g-12 g-md-6 g-lg-8 -p-relative order-2 order-md-1"
        >
          <StoreFinderFilter
            v-if="showFilterRow"
            v-show="viewFiltersDesktop"
            class="storefinder-block-search-filter"
            v-model="storeFilter"
            :options="toggleOptions"
            :backgroundColor="'transparent'"
            :fontColor="Globals.colors.black"
            :sliderColor="Globals.colors.white"
            @change="filterHasChanged"
          />

          <section
            class="-p-relative storefinder-block-streetview"
            :style="
              streetViewEnabled ? 'visibility: visible' : 'visibility: hidden'
            "
          >
            <div
              class="-clickable"
              style="position: absolute; top: 12px; right: 18px; z-index: 10"
              @click="hideStreetView()"
            >
              <SvgComponent
                :icon="{ name: 'Close', color: Globals.colors.white }"
                @click.native="hideStreetView()"
              />
            </div>
            <div ref="streetView" class="storefinder-block-streetview" />
          </section>
        </div>
        <div
          class="g-12 g-md-6 g-lg-4 order-1 order-md-2"
          v-click-outside="clickOutsideMenu"
        >
          <transition name="fade">
            <form
              v-if="
                !(
                  storeIsActive &&
                  ($mqAliases.sm || $mqAliases.xs) &&
                  mobileViewMode === 'full'
                )
              "
              ref="form"
              class="storefinder-block-form"
            >
              <InputFieldV2
                ref="search"
                v-model="searchAddress"
                class="search-field w-100"
                :id="'address'"
                :type="'search'"
                :block="true"
                tabindex="0"
                @focus="onInputFocus()"
              />
              <ButtonComponent
                class="button"
                @click="submit()"
                :theme="'main'"
                :overrideThemeColor="Globals.colors.blueDark"
                :small="false"
                tabindex="0"
                :text="insertString('StoreLocator', 'Search')"
              />
            </form>
          </transition>
          <!-- search results -->
          <div
            v-show="viewSearchBox && filteredStoreList.length > 0"
            ref="searchbox"
            class="storefinder-block-searchresult"
            :class="{ '-active': storeIsActive }"
          >
            <!-- <div class="d-flex justify-content-end">
              <div class="-clickable" @click="close()">
                <SvgComponent :icon="{ name: 'Close' }" />
              </div>
            </div> -->

            <div class="storefinder-block-searchresult-list">
              <StoreFinderResultItem
                :id="`store-${index}`"
                class="storefinder-block-searchresult-item font-body-xs font-responsive-md-small"
                v-for="(store, index) in filteredStoreList"
                :key="store.Model.Id"
                :compact="isMobile"
                :visible="
                  searchBoxStores.some(
                    (item) => item.Model.Id === store.Model.Id
                  )
                "
                :viewCloseButton="true"
                :store="store"
                :index="index"
                :open="storeIsActive"
                @close="closeActiveStore()"
                @on-toggle="
                  activeStoreIndex === null
                    ? setActiveStore(store.Model.Id, true)
                    : closeActiveStore()
                "
              >
                <StoreFinderCard
                  v-if="!isMobile && storeIsActive"
                  :store="store"
                  :photo="photos[store.Model.Id]"
                  :streetViewEnabled="streetViewEnabled"
                  @on-streetview-toggle="
                    streetViewEnabled ? hideStreetView() : viewStreetView(store)
                  "
                />
              </StoreFinderResultItem>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div
        class="map"
        :style="initialized ? 'opacity: 1' : 'opacity: 0'"
        ref="googleMap"
        id="map"
      />
    </section>
    <!-- mobile card drawer -->
    <section
      v-if="isMobile"
      ref="overlay"
      class="storefinder-block-drawer"
      :class="{
        '-open': storeIsActive,
        '-full': storeIsActive && mobileViewMode === 'full',
        '-dock': storeIsActive && mobileViewMode === 'dock',
        '-dragging': dragging,
      }"
    >
      <div class="storefinder-block-drawer-close d-flex justify-content-end">
        <div
          class="-clickable"
          @click="
            closeActiveStore();
            resetStoreMarkers();
          "
        >
          <SvgComponent :icon="{ name: 'Close' }" />
        </div>
      </div>
      <div class="storefinder-block-drawer-body">
        <div v-if="activeStore" class="grid font-responsive-body -p-relative">
          <div
            class="storefinder-block-drawer-drag"
            v-hammer:panstart="dragStart"
            v-hammer:panend="dragStop"
            v-hammer:pan="drag"
          >
            <div class="storefinder-block-drawer-drag-handle" />
          </div>
          <StoreFinderResultItem
            v-if="!streetViewEnabled"
            :class="mobileViewMode === 'full' ? 'm-t-12' : 'm-t-27'"
            :store="activeStore"
            :visible="true"
            :open="true"
            @close="
              () => {
                closeActiveStore();
              }
            "
          >
            <StoreFinderCard
              :store="activeStore"
              :photo="photos[activeStore.Model.Id]"
              :streetViewEnabled="streetViewEnabled"
              @on-streetview-toggle="
                streetViewEnabled
                  ? hideStreetView()
                  : viewStreetView(activeStore)
              "
            />
          </StoreFinderResultItem>
          <section
            class="-p-relative storefinder-block-streetview"
            :style="
              streetViewEnabled
                ? 'visibility: visible; position:absolute'
                : 'visibility: hidden; height: 0; overflow:hidden;'
            "
          >
            <div
              class="-clickable"
              style="position: absolute; top: 12px; right: 18px; z-index: 10"
              @click="hideStreetView()"
            >
              <SvgComponent
                :icon="{ name: 'Close', color: Globals.colors.white }"
                @click.native="hideStreetView()"
              />
            </div>
            <div ref="streetView" class="storefinder-block-streetview" />
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Api from '@/Scripts/api/api';
// import UrlHelper from '@/Scripts/lib/helper/urlHelper.js';
import stringHelper from '@/Scripts/lib/helper/stringHelper.js';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import { mapState } from 'vuex';
import { Loader } from '@googlemaps/js-api-loader';
import ScrollLock from '@/Scripts/lib/mixins/scrollLock.js';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import ImageCollectorHelper from '@/Scripts/lib/helper/imageCollectorHelper.js';
import InputFieldV2 from '@/Scripts/components/shared/InputFieldV2/InputFieldV2.vue';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';
import StoreFinderResultItem from '@/Scripts/components/pages/FindStore/StoreFinderResultItem.vue';
import StoreFinderCard from '@/Scripts/components/pages/FindStore/StoreFinderCard.vue';
import ClickOutside from 'vue-click-outside';
const StoreFinderFilter = () => import('@/Scripts/components/pages/FindStore/StoreFinderFilter.vue');

// apiKey: 'AIzaSyDZdNT7qnI8Fm9fZPwx598T-Bqnn1nxFTg', // dev
//  apiKey: 'AIzaSyDslOe2E8SKwB1hllp_shvSfp1U3MMF8eA', // prod

let map;
let panorama;

const defaultCenter = {
  lat: 59.913868,
  lng: 10.752245
};
const defaultZoom = 6;
const defaultZoomMobile = 11;
// const clusterRadius = 48;
let markerCluster;

const mapOptions = {
  center: defaultCenter,
  zoom: defaultZoom,
  minZoom: 3,
  maxZoom: 18,
  panControl: false,
  zoomControl: true,
  fullscreenControl: false,
  mapTypeControl: true,
  mapTypeControlOptions: {
    position: 10
  },
  streetViewControl: false,
  gestureHandling: 'greedy',

  styles: [
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [

      ]
    },
    {
      featureType: 'administrative.province',
      elementType: 'all',
      stylers: [
        {
          visibility: 'all'
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f7f7f7'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#efefef'
        }

      ]
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff'
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#e2e2e2'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [
        {
          color: '#ffffff'
        }

      ]
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#ffffff'
        }
      ]
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#878787'
        }
      ]
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }
  ]
};

function getTranslateXY (element) {
  const style = window.getComputedStyle(element);
  const matrix = new DOMMatrixReadOnly(style.transform);
  return {
    translateX: matrix.m41,
    translateY: matrix.m42
  };
}

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

export default {
  name: 'StoreFinderBlock',
  directives: {
    ClickOutside
  },
  mixins: [ScrollLock, siteInfo],
  components: {
    InputFieldV2,
    ButtonComponent,
    StoreFinderFilter,
    StoreFinderResultItem,
    StoreFinderCard,
    SvgComponent
  },
  props: {
    storeList: Array,
    images: Array
  },
  data () {
    return {
      initialized: false,
      userMarker: null,
      showFilterRow: true,
      viewSearchBox: false,
      streetViewEnabled: false,
      searchAddress: '',
      activeStoreIndex: null,

      activePop: null,
      mobileViewMode: 'normal',
      drawerPosition: 0,
      drawerStatus: ['dock', 'normal', 'full'],
      draggingDirection: 0,
      dragging: false,
      // storeFilter: ['RetailStore', 'PremiumDealer', 'Dealer', 'OutletStore', 'OnlineStore'],
      storeFilter: ['RetailStore', 'OutletStore', 'Dealer'],
      markers: {},
      placeData: {},
      photos: {},
      storeTypes: [
        {
          label: this.insertString('FindStore', 'NorronaStores'),
          icon: 'pin-black-no-outline.png',
          iconSelected: 'pin-black.png',
          color: '#1d1d1d',
          value: 'RetailStore'
        },
        // { label: 'Premium Retailers',
        //   icon: 'pin-dealers.png',
        //   color: '#747474',
        //   value: 'PremiumDealer' },
        {
          label: this.insertString('FindStore', 'OutletStores'),
          icon: 'pin-white.png',
          iconSelected: 'pin-white.png',
          color: '#fcfcfc',
          logoColor: '#1d1d1d',
          borderColor: '#1d1d1d',
          value: 'OutletStore'
        },
        {
          label: this.insertString('FindStore', 'Dealers'),
          color: '#349F74',
          icon: 'pin-green-no-outline.png',
          iconSelected: 'pin-green.png',
          value: 'Dealer'
        }
        // { label: 'Online stores',
        //   icon: 'pin-outlet.png',
        //   color: '#006BFF',
        //   value: 'OnlineStore' }
      ]
    };
  },
  watch: {
    googleApiKey: {
      immediate: true,
      handler (val) {
        if (val) {
          this.initMap(val);
        }
      }
    },
    storeList (val, old) {
      if (val && val.length > 0) {
        // reset
        Object.assign(this.markers, {});
        Object.assign(this.placeData, {});
        Object.assign(this.photos, {});
        this.populateMarkers();
      }
    },
    storeFilter (val, old) {
      if (val !== old) {
        this.populateMarkers();
      }
    },
    storeIsActive (val) {
      if (this.isMobile && !val) {
        this.mobileViewMode = 'normal';
        this.freeScroll();
      }
    }
  },
  computed: {

    ...mapState({
      googleApiKey: state => state.siteInfo.googleApiKey
    }),

    filteredStoreList () {
      return this.storeList.filter(store => this.storeFilter.includes(store.Model.Type));
    },
    activeStore () {
      return this.storeList[this.activeStoreIndex];
    },
    searchBoxStores () {
      const str = this.searchAddress.toLowerCase();
      const filteredList = str
        ? this.storeList.filter(x => x.Model.Name.toLowerCase().includes(str) || x.Model.VisitorAddress.City.toLowerCase().includes(str) || x.Model.VisitorAddress.Line1.toLowerCase().includes(str))
        : this.storeList;
      return this.storeIsActive ? [this.activeStore] : filteredList;
    },
    viewFiltersMobile () {
      return this.isMobile && !this.streetViewEnabled && !this.viewSearchBox && this.activeStoreIndex === null;
    },
    viewFiltersDesktop () {
      return !this.isMobile && !this.streetViewEnabled;
    },
    storeIsActive () {
      return this.activeStoreIndex !== null;
    },
    isMobile () {
      return this.$mqAliases.sm || this.$mqAliases.xs;
    },
    markerClusterOptions () {
      return {
        minimumClusterSize: 5,
        maxZoom: 11
      };
    },
    toggleOptions () {
      const list = [];
      this.storeTypes.forEach((val) => {
        list.push({ label: val.label, value: val.value, color: val.color, borderColor: val.borderColor, logoColor: val.logoColor });
      });
      return list;
    }
  },
  methods: {

    clickOutsideMenu () {
      if ((this.isMobile && this.viewSearchBox) || (!this.isMobile && this.viewSearchBox && this.activeStoreIndex === null)) {
        this.viewSearchBox = false;
        const input = this.$refs.search.$el.querySelectorAll('input');
        if (input) {
          input[0].blur();
        }
      }
    },
    onFilterList ($event) {
      this.filterString = $event;
    },
    dragStart () {
      this.dragging = true;
      const translate = getTranslateXY(this.$refs.overlay);
      this.drawerPosition = translate.translateY || 0;
    },
    dragStop () {
      setTimeout(() => {
        this.$refs.overlay.style.transform = '';
      }, 0);
      this.dragging = false;
      // find snap position
      const i = this.drawerStatus.indexOf(this.mobileViewMode);
      if (i !== -1) {
        let newStatus = i - this.draggingDirection;
        if (newStatus > this.drawerStatus.length - 1) {
          newStatus = this.drawerStatus.length - 1;
        } else if (newStatus < 0) {
          newStatus = 0;
        }
        this.mobileViewMode = this.drawerStatus[newStatus];
      } else {
        this.mobileViewMode = this.drawerStatus[0];
      }

      if (this.storeIsActive && this.mobileViewMode === 'full') {
        window.scrollTo(0, 0);

        this.lockScroll();
      } else {
        this.freeScroll();
      }
    },
    drag (e) {
      const pos = this.drawerPosition + e.deltaY;
      this.draggingDirection = e.deltaY > 0 ? 1 : -1;

      requestAnimationFrame(() => {
        if (this.dragging) {
          this.$refs.overlay.style.transform = 'translateY(' + pos + 'px)';
        }
      });
    },
    onInputFocus () {
      this.viewSearchBox = true;
      this.closeActiveStore();
    },
    getStreetView (settings, pos) {
      const svService = new google.maps.StreetViewService();
      const panoRequest = {
        source: settings && settings.ForceOutdoor ? google.maps.StreetViewSource.OUTDOOR : google.maps.StreetViewSource.DEFAULT,
        location: new google.maps.LatLng(pos.lat, pos.lng),
        preference: settings && settings.ForceBest ? google.maps.StreetViewPreference.BEST : google.maps.StreetViewPreference.NEAREST,
        radius: 150
      };
      svService.getPanorama(panoRequest, (panoData, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          panorama = new google.maps.StreetViewPanorama(this.$refs.streetView, { pano: panoData.location.pano });
          panorama.setOptions({
            linksControl: false,
            enableCloseButton: false,
            panControl: false,
            fullscreenControl: false
          });
          const markerPano = new google.maps.Marker({
            position: {
              lat: pos.lat,
              lng: pos.lng
            },
            map: panorama
          });
          const heading = google.maps.geometry.spherical.computeHeading(panoData.location.latLng, markerPano.getPosition());
          panorama.setPov({
            heading: heading,
            pitch: 0
          });
          this.streetViewEnabled = true;
        }
      });
    },
    getStoreCoords (store) {
      // don't use placeData from google, Cost Saver Fix

      // const placeData = this.placeData[store.Model.Id];
      if (store.StreetView && store.StreetView.Latitude && store.StreetView.Longitude) {
        return { lat: store.StreetView.Latitude, lng: store.StreetView.Longitude }; // coords from store streetview settigns
      } else if (store.Coordinate.Latitude && store.Coordinate.Longitude) {
        return { lat: store.Coordinate.Latitude, lng: store.Coordinate.Longitude }; // coords from store
      // } else if (placeData && placeData.geometry && placeData.geometry.location) {
      //   return { lat: placeData.geometry.location.lat(), lng: placeData.geometry.location.lng() }; // coords from google places
      }
      return null;
    },
    viewStreetView (store) {
      this.mobileViewMode = 'full';
      this.getStreetView(store.StreetView, this.getStoreCoords(store));
    },
    hideStreetView () {
      this.streetViewEnabled = false;
    },
    closeActiveStore () {
      setTimeout(() => {
        this.activeStoreIndex = null;
        stringHelper.replaceUrlState(stringHelper.removeUrlParameter(window.location.href, 'store'));
        if (this.streetViewEnabled) {
          this.hideStreetView();
        }
      }, 100);
    },
    activeStoreMode () {
      if (this.isMobile) {
        this.viewSearchBox = false;
        this.searchAddress = '';
        this.mobileViewMode = 'normal';
        window.scrollTo(0, 0);
      } else {
        this.viewSearchBox = true;
      }
    },
    setActiveStore (id, zoom = false, pan = true) {
      const index = this.storeList.findIndex(store => store.Model.Id === id);
      this.activeStoreMode();
      this.hideStreetView();
      if (index !== this.activeStoreIndex) {
        const store = this.storeList[index];
        if (store) {
          stringHelper.replaceUrlState(stringHelper.updateUrlParameter(window.location.href, 'store', store.Model.Id));

          if (zoom) {
            map.setZoom(12);
          }
          this.resetStoreMarkers();
          this.setActiveIcon(store);
          if (pan) {
            map.panTo(this.markers[store.Model.Id].getPosition());
          } else {
            map.setCenter(this.markers[store.Model.Id].getPosition());
          }
          this.panCustomShifted();
          this.activeStoreIndex = index;
          if (!this.placeData[store.Model.Id]) {
            const imgs = this.images ? this.images.filter(i => i.StoreId === store.Model.Id) : null;
            if (imgs && imgs.length) {
              const photo = ImageCollectorHelper.buildMediaObject(imgs[0], 5 / 4);
              this.$set(this.photos, store.Model.Id, photo.src);
            } else {
              this.getStorePlaceData(store);
            }
          }
        }
      } else {
        this.closeActiveStore();
      }
    },
    setActiveIcon (store) {
      const iconUrl = this.getStoreIconUrl(store, true);
      const marker = this.markers[store.Model.Id];
      if (iconUrl && marker) {
        marker.setIcon({
          url: require(`@/Assets/markers/${iconUrl}`),
          scaledSize: new google.maps.Size(40, 64) // scaled size
        });
      }
    },
    setActiveStoreFromUrl () {
      const storeKeyFromUrl = stringHelper.getURLParameter('store');
      if (storeKeyFromUrl) {
        this.setActiveStore(storeKeyFromUrl, true, false);
      }
    },
    panCustomShifted () {
      if (this.$mqAliases.desktop) {
        map.panBy(200, 0);
      } else {
        map.panBy(0, 150);
      }
    },
    getStorePlaceData (store) {
      const service = new google.maps.places.PlacesService(map);
      const placeId = store.Model.GooglePlaceId;
      if (placeId) {
        //  Cost Saver Fix: don't get geometry from google, shold not be needed.. Was used for Street View. Use storeCoords from Insight
        // service.getDetails({ placeId: placeId, fields: ['photos', 'geometry'] }, (result, status) => {
        service.getDetails({ placeId: placeId, fields: ['photos'] }, (result, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.savePlaceData(store, result);
          } else {
            console.log('couldnt find store');
          }
        });
      } else {
        console.log('placeId missing');
        //  Cost Saver Fix: Don't use text search for getting data on stores without placeID. PlaceId should be added in Insight instead
        // service.textSearch({ query: store.Model.Name }, (results, status) => {
        //   if (status === google.maps.places.PlacesServiceStatus.OK) {
        //     console.log(store.Model.Id + ': "' + results[0].place_id + '"');
        //     if (results && results[0]) {
        //       this.savePlaceData(store, { photos: results[0].photos });
        //     }
        //   } else {
        //     console.log('couldnt find store');
        //   }
        // });
      }
    },
    savePlaceData (store, placeData) {
      this.$set(this.placeData, store.Model.Id, placeData);
      if (store.Model.Type === 'Dealer') {
        // Cost Saver Fix: don't get Dealer openingHours. can be turned on if needed
        // this.getOpeningHours(store); // get openinghours from google
      }
      if (placeData.photos && placeData.photos.length >= 1) {
        const photo = placeData.photos[0].getUrl();
        this.$set(this.photos, store.Model.Id, photo);
      }
    },
    // getOpeningHours (store) {
    //   const placeId = store.Model.GooglePlaceId || this.placeData[store.Model.Id].place_id;
    //   if (placeId) {
    //     const request = {
    //       placeId: placeId,
    //       fields: ['opening_hours', 'utc_offset_minutes', 'formatted_phone_number']
    //     };
    //     const service = new google.maps.places.PlacesService(map);
    //     service.getDetails(request, (place, status) => {
    //       if (status === google.maps.places.PlacesServiceStatus.OK) {
    //         if (place.formatted_phone_number) {
    //           this.$set(store, 'formattedPhoneNumber', place.formatted_phone_number);
    //         }
    //         if (place.opening_hours && place.utc_offset_minutes) {
    //         // this.$set(store, 'openNow', place.opening_hours.isOpen());
    //           this.$set(store, 'openData', place.opening_hours.weekday_text);
    //         }
    //       } else {
    //         console.log('couldnt find store data');
    //       }
    //     });
    //   }
    // },
    getStoreIconUrl (store, selected = false) {
      let icon = null;
      const type = this.storeTypes.find(s => s.value === store.Model.Type);
      if (type) {
        icon = `${!selected ? type.icon : type.iconSelected}`;
      }
      return icon;
    },
    createStoreMarker (store, index) {
      const iconUrl = this.getStoreIconUrl(store);
      const icon = iconUrl
        ? {
            url: require(`@/Assets/markers/${iconUrl}`)
          }
        : null;
      if (store.Coordinate) {
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(store.Coordinate.Latitude, store.Coordinate.Longitude),
          title: store.Model.SearchName,
          id: index,
          icon: icon

        });
        this.$set(this.markers, store.Model.Id, marker);
        marker.addListener('click', () => {
          this.setActiveStore(store.Model.Id);
        });

        return marker;
      }
      return null;
    },
    resetStoreMarkers () {
      this.storeList.forEach((store, index) => {
        if (this.storeFilter.includes(store.Model.Type)) {
          const iconUrl = this.getStoreIconUrl(store);
          const marker = this.markers[store.Model.Id];
          if (iconUrl && marker) {
            marker.setIcon(require(`@/Assets/markers/${iconUrl}`));
          }
        }
      });
    },
    populateMarkers () {
      markerCluster.clearMarkers();
      this.$nextTick(() => {
        this.storeList.forEach((store, index) => {
          if (this.storeFilter.includes(store.Model.Type)) {
            const marker = this.createStoreMarker(store, index);
            if (marker) {
              markerCluster.addMarker(marker);
            }
            if (index === this.activeStoreIndex) {
              this.setActiveIcon(store);
            }
          }
        });

        // init (only first time)
        if (!this.initialized) {
          this.setActiveStoreFromUrl();
          this.initialized = true;
        }
      });
    },
    filterHasChanged ($event) {
      // console.log($event);
    },
    submit () {
      if (this.isMobile) {
        this.viewSearchBox = false;
      }
      let address = this.searchAddress;
      if (!isNaN(parseInt(address, 10))) {
        address = `postal_code:${address}`;
      }

      new google.maps.Geocoder().geocode({
        address
      }, (response, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          map.setCenter(new google.maps.LatLng(response[0].geometry.location.lat(), response[0].geometry.location.lng()));
          map.setZoom(10);
          if (this.viewSearchBox) {
            this.panCustomShifted();
          }
        }
      });
    },
    setMapToUserLocation () {
      // center to user location, if not accepted try to center to countrycode location, if not default center to eur

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
          map.setZoom(!this.isMobile ? defaultZoom : defaultZoomMobile);
          if (this.viewSearchBox) {
            this.panCustomShifted();
          }
          if (this.$mqAliases.xs || this.$mqAliases.sm) {
            this.watchUserPos();
          }
          this.$emit('on-location', position.coords);
        }, (error) => {
          console.log(error);
          this.setMapToCountryLocation(); // country location backup
        });
      } else {
        this.setMapToCountryLocation(); // country location backup
      }
    },
    async setMapToCountryLocation () {
      const countryName = await this.getCurrentCountry();
      if (countryName) {
        new google.maps.Geocoder().geocode({ address: countryName }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            map.fitBounds(results[0].geometry.bounds);
          } else {
            console.log('Geocode was not successful for the following reason: ' + status);
          }
        });
      }
    },
    watchUserPos () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.userMarker = new google.maps.Marker({
          position: map.getCenter(),
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#ffffff',
            fillOpacity: 10,
            scale: 5,
            strokeColor: this.Globals.colors.blueDark,
            strokeWeight: 2
          },
          map: map
        });
      });
      navigator.geolocation.watchPosition(position => {
        const pos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.userMarker.setPosition(pos);
      });
    },
    async getCurrentCountry () {
      const result = await Api.get('/api/country/current');
      if (result && result.data) {
        return result.data.CountryName;
      }
      return null;
    },
    addMarkerCluster () {
      const markers = [];

      // const renderer = {
      //   render ({ count, position }, stats) {
      //     // const svg = window.btoa(`
      //     //       <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      //     //         <circle cx="24" cy="24" r="24" fill="#1d1d1d" />
      //     //         <text x="50%" y="50%" dy="5px" text-anchor="middle" fill="#ffffff" font-size="13px" font-family='"DIN Next Pro", "helvetica", "helvetica neue", "arial", sans-serif'>${count}</text>
      //     //       </svg>`);
      //     return new google.maps.Marker({
      //       position,
      //       // icon: {
      //       //   url: `data:image/svg+xml;base64,${svg}`,
      //       //   scaledSize: new google.maps.Size(clusterRadius, clusterRadius)
      //       // },
      //       title: `Cluster of ${count} markers`,
      //       zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
      //     });
      //   }
      // };
      const algorithm = new SuperClusterAlgorithm({ map: map, radius: 160, minPoints: 3, maxZoom: 8 });
      markerCluster = new MarkerClusterer({ map, markers, algorithm });
    },
    initMap (key) {
      const loader = new Loader({
        apiKey: key,
        version: 'weekly',
        libraries: ['places']
      });
      loader.load().then(() => {
        map = new google.maps.Map(this.$refs.googleMap, mapOptions);
        map.addListener('mousedown', () => {
          if (this.mobileViewMode === 'normal') {
            this.mobileViewMode = 'dock';
          }
        });
        this.addMarkerCluster();
        this.$emit('ready');
        this.setMapToUserLocation();
        const link = document.getElementById('intercom-container');
        if (link) {
          link.style.display = 'none'; // hide intercom
        }
      }).catch(e => {
        console.error(e);
      });
    }
  },

  mounted () {
    this.$nextTick(() => {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panorama.getVisible()) {
          this.hideStreetView();
        }
      });
    });
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";

:root {
  --app-height: 100%;
}
.storefinder-block {
  position: relative;
  .map {
    transition: opacity 0.33s;
  }
  &-search {
    position: absolute;
    top: 24px;
    left: 0;
    width: 100%;
    z-index: 10;
    pointer-events: none;
    max-height: calc(100vh - 150px);
    @include media-breakpoint-up(md) {
    }
  }
  &-search-filter {
    margin-top: 18px;
    @include media-breakpoint-up(md) {
      margin-top: 60px;
    }

    @include media-breakpoint-up(lg) {
      margin-top: 0;
    }
    @include media-breakpoint-down(sm) {
      position: absolute;
      top: 18px;
      left: 18px;
      z-index: 100;
    }

    pointer-events: all;
  }
  &-list {
    padding-right: 18px;
    height: 600px;
    overflow-y: scroll;
    @include pretty-scrollbars;
  }
  &-form {
    display: flex;
    height: 48px;
    border: 1px solid #1d1d1d;
    background-color: $white;
    border-radius: 6px;
    margin: 0;
    overflow: hidden;
    pointer-events: all;
    transition: all 0.21s ease-out;
    .search-field {
      margin: 0;
      padding: 0;
      input {
        height: 48px;
        border: none;
        font-size: 18px;
      }
    }
    .button {
      align-self: center;
      max-height: 42px;
      margin-right: 2px;
    }
  }
  &.-full {
    .storefinder-block-form {
      // position: absolute;
      // width: 100%;
      // left: 0;
      // top: -23px;
      // border-radius: 0;
      // border: none;
      // border-top: 1px solid $gray-light;
      // .btn-v2 {
      //   margin-right: 18px;
      // }
    }
  }
  &-searchresult {
    pointer-events: all;
    overflow: auto;
    margin-top: 12px;
    border-radius: 6px;

    background-color: $white;
    padding: 12px 18px 24px 18px;
    max-height: calc(50vh - 90px);
    @include media-breakpoint-up(md) {
      max-height: calc(100vh - 180px);
      box-shadow: 1px 1px 6px 0 rgba(0, 0, 0, 0.25);
    }
    overflow-y: scroll;
    &.-active {
      overflow-y: auto;
      height: auto;
    }
    > div > div {
      padding-top: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid $gray;
    }
  }
  &-streetview {
    width: 100%;
    height: calc(56.25vw - 120px);
    max-height: calc(100vh - 180px);
    pointer-events: all;
    border-radius: 6px;
    box-shadow: 1px 1px 6px 0 rgba(0, 0, 0, 0.25);
    @include media-breakpoint-down(sm) {
      height: 100vh;
      max-height: calc(100vh - 180px);
      box-shadow: none;
      border-radius: 0;
    }
  }
  &-drawer {
    position: fixed;
    top: unset !important;
    bottom: 0;
    z-index: 10;
    width: 100%;
    /* width gap: height: 152px*/
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    height: calc(var(--app-height) - 60px);
    max-height: calc(var(--app-height) - 60px);
    transform: translateY(100%);
    background-color: $gray-lighter;
    border-top: 1px solid $gray-light;
    @include media-breakpoint-up(md) {
      padding-bottom: 60px;
    }

    &:not(.-dragging) {
      transition: all 0.21s ease-out;
    }
    &.-open {
      transform: translateY(calc(100% - 50vh));
      &.-full {
        .storefinder-block-drawer-drag-handle {
          display: none;
        }
        &:not(.-dragging) {
          transform: translateY(0) !important;
          .storefinder-block-drawer-body {
            overflow: scroll;
          }
        }
      }
      &.-dock {
        transform: translateY(calc(100% - 120px));
      }
    }
    &-body {
      overflow: hidden;
      height: 100%;
    }
    &-close {
      position: absolute;
      top: 12px;
      right: 18px;
      z-index: 1;
    }

    &-drag {
      position: absolute;
      width: 70%;
      height: 350px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      display: flex;
      justify-content: center;
      padding-top: 12px;
      padding-bottom: 12px;
      pointer-events: all;
      cursor: grab;
      &-handle {
        width: 32px;
        height: 6px;
        padding-top: 3px;
        border-top: 1px solid $gray-dark;
        border-bottom: 1px solid $gray-dark;
      }
    }
  }
  &-opendata {
    text-transform: capitalize;
  }
  #map {
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    min-width: 100%;
    max-width: 100%;
    *:focus {
      outline: none !important;
    }
  }
}
</style>
